import { Messages } from "../../lib/locale";

export const Spanish: Messages = {
  name: "Español",
  helpTitle: "Como jugar",
  help1: `Tu tarea es descubrir qué país está oculto en el juego. Para hacer esto, debe ingresar los nombres de países aleatorios. Escriba el país en el cuadro de entrada y presione Entrar. Este país aparecerá en el mapa y cambiará de color según lo cerca que esté del país oculto. ¡Cuanto más oscuro sea el color, más cerca estarás de la respuesta!`,
  help2: `Mira el ejemplo del juego. Digamos que el país Japón está oculto en el juego. Entonces estos países serán pintados con esos colores.`,
  help3: `Una vez al día, un nuevo país oculto está disponible. O cambie al modo libre en la configuración y juegue sin límites.`,
  France: "Francia",
  Nepal: "Nepal",
  Mongolia: "Mongolia",
  "South Korea": "Corea del Sur",
  Aux1: `<b>["¡Haz clic en", "¡Toca"]</b> el globo para comenzar!`,
  Loading: "Espéralo...",
  GameTitle: "Juego",
  Game1: "Ingrese el nombre del país aquí",
  Game2: "Ingresar",
  Game3: "Ingresa el nombre de cualquier pais para iniciar el juego.",
  Game4: `Gira, <span>["haz clic", "toca"]</span> y haz zoom en el globo para encontrar el siguiente país para adivinar`,
  Game5: "No conocemos este país",
  Game6: "Este país ya está ingresado",
  Game7: "El País Oculto era {answer}!",
  Game8: "Frontera más cercana",
  StatsTitle: "Estadísticas",
  Stats1: "Última victoria",
  Stats2: "Conjeturas de hoy",
  Stats3: "Juegos ganados",
  Stats4: "Racha actual",
  Stats5: "Racha máxima",
  Stats6: "Conjeturas promedio",
  Stats7: "Conjeturas promedio",
  Stats8: "Reiniciar",
  Stats9: "Cuota",
  Stats10: "¿Estás seguro de que quieres restablecer tu puntuación?",
  Stats11: "Estadísticas borradas.",
  Stats12: "Copiado al portapapeles!",
  SettingsTitle: "Ajustes",
  Settings1: "Tema del día",
  Settings2: "Tema de la noche",
  Settings3: "Modo daltónico",
  Settings4: "Modo daltónico",
  Settings5: "Países",
  Settings7: "Idioma",
  Settings9: "Modo libre",
  Settings10: "Sugerencia",
  Answer: "Responder",
  Closest: "Mas cercano",
  Guessed: "Adivinado",
  PracticeMode: "Estás en modo libre",
  PracticeExit: "Salir del modo libre",
  PracticeNew: "Nuevo juego gratis",
  PlayAgain: "Juega de nuevo",
  SortBy: "Ordenar por:",
  SortByGuesses: "orden de conjetura",
  SortByDistance: "distancia",
  Clipboard: "🌍🌍🌍\nAdiviné el país oculto en Globle de hoy en {X} intentos\n¿Puedes hacerlo mejor?\nhttps://globlegame.org/\n#globle\n🌍🌍🌍",
  Victory: "Victoria",
  Guesses: "Suposiciones",
  GuessesFlags: "Tus conjeturas estarán aquí",
  Daily: "Diario",
  NextDailyIn: "Siguiente Diario",
  Learn: "Aprende sobre este país"
};